import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import BigImage from '../../components/BigImage'
import Paginate from '../../components/Paginate'
import Paragraph from '../../components/Paragraph'
import Prompts from '../../components/Prompts'
import SectionHeader from '../../components/SectionHeader'
import Stories from '../../components/Stories'
import UnorderedList from '../../components/UnorderedList'
import patient from '../../stores/patient'
import Survey from './Survey'

@observer
export default class GoalSession3 extends Component {
  render() {
    return (
      <Fragment>
        {/* SURVEY */}
        <SectionHeader color="red" icon="fas fa-list" str="titles.survey" />
        <Survey />
        {/* STORIES */}
        <SectionHeader color="red" icon="fas fa-users" str="titles.stories" />
        <Prompts>
          <Prompts.P>
            <Paragraph str="prose.likeWeHeardInFirstSession" />
            <UnorderedList>
              <UnorderedList.Item str="prose.notSureMedicationHelping" />
              <UnorderedList.Item str="prose.dontFeelConfident" />
              <UnorderedList.Item str="prose.notUnderstandingGlaucoma" />
              <UnorderedList.Item str="prose.theSideEffects" />
              <UnorderedList.Item str="prose.notSurePutInDrops" />
              <UnorderedList.Item str="prose.troublePaying" />
              <UnorderedList.Item str="prose.fearingAddiction" />
              <UnorderedList.Item str="prose.forgettingTakeDrops" />
              <UnorderedList.Item str="prose.tooMuchGoingOn" />
              <UnorderedList.Item str="prose.forgettingSchedule" />
              <UnorderedList.Item str="prose.embarrassedTellFamily" />
              <UnorderedList.Item str="prose.uncomfortableInPublic" />
              <UnorderedList.Item str="prose.notConfidentInDoctor" />
            </UnorderedList>
            <Paragraph str="prose.wonderWhichOfThese" />
          </Prompts.P>
        </Prompts>
        <BigImage src={patient.ethnicityImage} />
        <Stories hidePrompts={true} />
        <Prompts>
          <Prompts.Q str="prose.whichIfAnyIdeas" />
          <Prompts.R str="prose.itSoundsLike" />
          <Prompts.P>
            <Paragraph str="prose.greatNextArea" />
            <Paragraph str="prose.orSayNextArea" />
          </Prompts.P>
        </Prompts>
        {/* PAGINATE */}
        <Paginate>
          <Paginate.Button
            color="blue"
            str="titles.learn"
            to={`/learn/third/${patient.fields._id}`}
          />
          <Paginate.Button next
            color="orange"
            str="titles.use"
            to={`/use/third/${patient.fields._id}`}
          />
        </Paginate>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Goal/GoalSession3.js